//お客様が指定できる受取り時間は、「現在までの受取り時間」+「10分」以降を表示
export const MIN_SELECT_MINUTES = 10; //10分

export type Time = {
  hour: number;
  minute: number;
};

export const convertTime = (time: string): Time => {
  const [hour, minute] = time.split(":").map((t) => parseInt(t, 10));
  return { hour, minute };
};

export const convertTimeToString = (time: Time): string => {
  return `${time.hour.toString().padStart(2, "0")}:${time.minute
    .toString()
    .padStart(2, "0")}`;
};

export const isTimeValid = (time: string): boolean => {
  const [hour, minute] = time.split(":").map((t) => parseInt(t, 10));
  return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
};

export const isTimeBefore = (time1: Time, time2: Time): boolean => {
  return (
    time1.hour < time2.hour ||
    (time1.hour === time2.hour && time1.minute < time2.minute)
  );
};

export const isTimeEqual = (time1: Time, time2: Time): boolean => {
  return time1.hour === time2.hour && time1.minute === time2.minute;
};

export const isTimeBeforeMinutes = (
  time1: Time,
  time2: Time,
  minutes: number,
): boolean => {
  return isTimeBefore(time1, addMinutes(time2, minutes));
};

export const getTimeRangeByInterval = (
  start: Time,
  end: Time,
  interval: number = 10,
): Time[] => {
  const times: Time[] = [];
  let currentTime = { ...start };
  while (isTimeBefore(currentTime, end)) {
    times.push({ ...currentTime });
    currentTime.minute += interval;
    if (currentTime.minute >= 60) {
      currentTime.hour += 1;
      currentTime.minute = 0;
    }
  }
  return times;
};

export const getMaxTime = (...args: Time[]): Time => {
  return args.reduce((max, time) => {
    return isTimeBefore(max, time) ? time : max;
  }, args[0]);
};

export const addMinutes = (time: Time, minutes: number): Time => {
  const newTime = { ...time };
  newTime.minute += minutes;
  if (newTime.minute >= 60) {
    newTime.hour += 1;
    newTime.minute -= 60;
  }
  return newTime;
};

export const getCurrentTime = (roundUpToNearest10: boolean = true): Time => {
  const now = new Date();

  if (roundUpToNearest10) {
    const minute = now.getMinutes() + now.getSeconds() / 60;
    const roundedMinute = Math.ceil(minute / 10) * 10;
    if (roundedMinute === 60) {
      return { hour: now.getHours() + 1, minute: 0 };
    }
    return { hour: now.getHours(), minute: roundedMinute };
  }

  return { hour: now.getHours(), minute: now.getMinutes() };
};
